import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { Planner } from "@app/models/rest/planner";

@Injectable({
  providedIn: "root"
})
export class PlannerRestService extends HateoasResourceOperation<Planner> {
  constructor() {
    super(Planner);
  }
}
